import type { Branded } from "@@/utilities/branded";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

type DiscountConditionId = Branded<string, "DiscountConditionId">;
const createDiscountConditionId = (): DiscountConditionId =>
    generateId({ prefix: "discount_condition__" });
const discountConditionIdZodSchema = z
    .string()
    .regex(
        /^discount_condition__.*$/,
    ) as unknown as z.ZodSchema<DiscountConditionId>;

export { createDiscountConditionId, discountConditionIdZodSchema };
export type { DiscountConditionId };
